"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProviderName;
(function (ProviderName) {
    ProviderName["RB"] = "RB";
    ProviderName["OPTA"] = "OPTA";
})(ProviderName = exports.ProviderName || (exports.ProviderName = {}));
//# sourceMappingURL=providers.js.map